export const chatModule = {
  namespaced: true,
  state: {
    messages: [
      {
        id: 0,
        from: "me",
        message: "This is a chat message",
        sid: "0"
      }
    ],
    nextId: 1  
  },
  getters: {
    getMessages(state) {
      return id => state.messages.filter(item =>{
        return item.sid === id
      });
    }
  },
  mutations: {
    loadMessages (state) {
      const channel = "messages"

      if (localStorage.getItem(channel) === null || JSON.parse(localStorage.getItem(channel)).length == 0) {
        state.messages = []
      } else {
        // console.log('looking at', localStorage.getItem(channel))
        state.messages = JSON.parse(localStorage.getItem(channel))
        let currentLastId = Math.max.apply(Math, state.messages.map(function(o) { return o.id; }))
        state.nextId = ++currentLastId
      }
      
    },
    setMessages (state, payload) {
      state.messages = payload
      localStorage.setItem('messages', JSON.stringify(payload))
    },
    addMessage (state, payload) {
      let sid = ( payload.sid ? payload.sid : null)
      let newMessage = {
        ...{message: payload.message, from: payload.from, sid: sid},
        id: state.nextId++
      }
      state.messages.push(newMessage)
      localStorage.setItem('messages', JSON.stringify(state.messages))
    },
    deleteMessage(state, toRemove) {
      state.messages = state.messages.filter(
        message => message.id !== toRemove.id
      )
    }
  },
  actions: {
    loadMessages (context, payload) {
      context.commit('loadMessages', payload)
    },
    setMessages (context, payload) {
      context.commit('setNotes', payload)
    },
    addMessage (context, payload) {
      context.commit('addMessage', payload)
    },
    removeMessage (context, payload) {
      context.commit('deleteMessage', payload)
      // context.commit('setMessages', context.state.messages)
    }
  }
}